import api from '../../../services/Api';
import { IAuditoriaIntegridadeLancamentosResultado } from '../interfaces/IAuditoriaIntegridadeLancamentos';

export const AuditoriaIntegridadeLancamentosService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaIntegridadeLancamentosResultado> {
    const response = await api.get<IAuditoriaIntegridadeLancamentosResultado>('auditoria-integridade-lancamentos/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoIntegridade: '',
        lancamentosGenericos: [],
      }
    );
  },
};
